import { combineReducers } from 'redux';

import authReducer from './auth';
import userReducer from './user';
import issuerReducer from './issuer-reducer';

const rootReducer = combineReducers({
  authState: authReducer,
  userState: userReducer,
  issuerState: issuerReducer,
});

export default rootReducer;
